import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledBeforeYouBuy = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
  Title: styled.p`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  List: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  Answer: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_LIGHT};
  `,
}
